import { useMediaQuery } from '@ori-ui/mui';
export var useIsMobile = function useIsMobile() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    options = _ref.options;
  return useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  }, options);
};
//# sourceMappingURL=useIsMobile.js.map